module.exports = __webpack_public_path__ + "static/media/avatar-26.bf1b9ad4.svg";